<template>
  <base-modal
    :ref="modal.key"
    :show="open"
    :title="modal.title"
    @on-confirm="onGrouped"
    @on-cancel="hide()"
    :okText="$t('ToGroup')"
    :closeText="$t('Close')"
    maxWidth="80%"
  >
    <div v-for="(item, index) in groupItems" :key="item.uuid">
      <v-row>
        <v-col cols="auto" align-self="center">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                tile
                large
                color="error"
                icon
                @click="removeGroup(item.uuid)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("Remove") }}</span>
          </v-tooltip>
        </v-col>
        <v-col align-self="center">
          <v-autocomplete
            v-model="item.fieldTitle"
            v-bind:label="$t('GroupBy')"
            :items="getFieldTitles(item)"
            :error-messages="fieldTitleErrors(index)"
          ></v-autocomplete>
        </v-col>
        <v-col align-self="center">
          <v-autocomplete
            v-model="item.sumFields"
            :items="getFieldTitlesForSummarize(true)"
            v-bind:label="$t('Sum')"
            multiple
          ></v-autocomplete>
        </v-col>
        <v-col align-self="center">
          <v-autocomplete
            v-model="item.maxFields"
            :items="getFieldTitlesForSummarize()"
            v-bind:label="$t('MaxValue')"
            multiple
          ></v-autocomplete>
        </v-col>
        <v-col align-self="center">
          <v-autocomplete
            v-model="item.minFields"
            :items="getFieldTitlesForSummarize()"
            v-bind:label="$t('MinValue')"
            multiple
          ></v-autocomplete>
        </v-col>
        <v-col align-self="center">
          <v-autocomplete
            v-model="item.avgFields"
            :items="getFieldTitlesForSummarize(true)"
            v-bind:label="$t('AvgValue')"
            multiple
          ></v-autocomplete>
        </v-col>
        <v-col align-self="center">
          <v-switch
            v-model="item.summarizeOnlySelectedDocuments"
            :label="$t('SummarizeOnlySelectedDocuments')"
          ></v-switch>
        </v-col>
        <v-col cols="auto" align-self="center" class="ml-auto">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                v-show="showAddButton"
                v-on="on"
                tile
                large
                color="primary"
                icon
                @click="addGroup()"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("Add") }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-subheader v-if="!isLastGroup(item.uuid)"
        >--- {{ $t("ThenBy") }} ---</v-subheader
      >
    </div>
  </base-modal>
</template>
<script>
import GroupItem from "@/ecm/models/search/GroupItem";
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import FieldType from "@/ecm/variables/FieldType";
import Utils from "@/ecm/common/Utils.js";

export default {
  name: "GroupModal",
  props: {
    fieldList: {
      type: Array,
      default: () => [],
    },
  },
  created() {
    this.addGroup();
  },
  data() {
    return {
      modal: {
        title: this.$t("ToGroup"),
        key: "groupModal",
      },
      open: false,
      groupItems: []
    };
  },
  mixins: [validationMixin],
  validations: {
    groupItems: {
      $each: {
        fieldTitle: { required },
      },
    },
  },
  computed: {
    modalInstance() {
      return this.$refs[this.modal.key];
    },
    showAddButton() {
      var fieldTitles = Array.from(
        new Set(this.fieldList.filter((f) => f.IsVisible).map((f) => f.Title))
      );
      return this.groupItems.length < fieldTitles.length;
    },
  },
  methods: {
    getFieldTitles(item) {

      if (this.fieldList || this.fieldList.length > 0) {
        var fieldTitles = Array.from(
          new Set(this.fieldList.filter((f) => f.IsVisible).map((f) => f.Title))
        );
        fieldTitles = fieldTitles.filter(
          (f) =>
            !this.groupItems.some(
              (gi) => gi.fieldTitle == f && gi.uuid != item.uuid
            )
        );
        return fieldTitles;
      } else {
        return [];
      }
    },
    getFieldTitlesForSummarize(onlyNumeric) {
      if (this.fieldList || this.fieldList.length > 0) {
        return Array.from(
          new Set(
            this.fieldList
              .filter(
                (f) =>
                  (f.IsVisible &&
                    f.Type == FieldType.DateTime &&
                    !onlyNumeric) ||
                  f.Type == FieldType.Numeric
              )
              .map((f) => f.Title)
          )
        );
      } else {
        return [];
      }
    },
    fieldTitleErrors(index) {
      const errors = [];
      if (!this.$v.groupItems.$each[index].fieldTitle.$dirty) return errors;
      !this.$v.groupItems.$each[index].fieldTitle.required &&
        errors.push(this.$t("RequiredField"));
      return errors;
    },
    addGroup() {
      this.groupItems.push(new GroupItem());
    },
    removeGroup(uuid) {
      this.groupItems = this.groupItems.filter((item) => item.uuid !== uuid);
      if (this.groupItems.length == 0) {
        this.addGroup();
      }
    },
    onGrouped() {

      if (this.groupItems.length == 1 && this.groupItems[0].fieldTitle == "") {
        this.$emit("on-grouped", []);
        this.hide();
      } else {
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }

        let cloned = this.groupItems.map(item => {
          return Utils.object.clone(new GroupItem(), item)
        });

        this.$emit("on-grouped", cloned);

        this.hide();
      }
    },
    show(lastGroupOptions) {
      this.open = true;
      this.$v.$reset();

      if (lastGroupOptions) {
        this.groupItems = lastGroupOptions;
      } else if (this.groupItems.length == 0) {
        this.addGroup();
      }
    },
    hide() {
      this.groupItems = this.groupItems.filter((gi) => gi.fieldTitle);
      this.open = false;
      this.$v.$reset();
    },
    isLastGroup(uuid) {
      if (this.groupItems.length <= 1) return true;
      return this.groupItems[this.groupItems.length - 1].uuid == uuid;
    },
  },
};
</script>